"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const igt_name_map_1 = require("../utils/igt-name-map");
const issue_mapper_1 = require("../utils/issue-mapper");
const get_screenshot_url_1 = require("../utils/get-screenshot-url");
function default_1(issues, { baseScreenshotURL } = {}) {
    const createdAt = new Date().toISOString();
    return JSON.stringify(issues.map(issue => ({
        ruleId: issue.rule,
        description: issue.description,
        help: issue.helpText,
        helpUrl: issue.helpUrl,
        impact: issue.impact,
        needsReview: !!issue.isNeedsReview,
        isManual: issue.isManual,
        selector: issue.selector,
        summary: issue.summary,
        source: issue.source,
        tags: (0, issue_mapper_1.getIssueTags)(issue),
        igt: (0, igt_name_map_1.getIgtName)(issue.igtTool),
        testName: issue.testName,
        shareURL: issue.shareURL,
        createdAt: issue.createdAt || createdAt,
        testUrl: issue.testUrl,
        testPageTitle: issue.testPageTitle,
        foundBy: issue.foundBy,
        axeVersion: issue.axeVersion,
        screenshotURL: (0, get_screenshot_url_1.getScreenshotUrl)(baseScreenshotURL, issue.screenshotId)
    }))).replace(/\\n/g, '\\\\n');
}
exports.default = default_1;
//# sourceMappingURL=json-axe-devtools.js.map